module.exports = __webpack_public_path__ + "static/media/scholastic_icon71cf8ec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/scholastic_icon.svg
// module id = 1339
// module chunks = 0